import { Button, Table } from 'antd';
import React from 'react'
import { DeleteOutlined, EditOutlined, ArrowRightOutlined } from '@ant-design/icons';

interface IProps {
	onEdit?: (content: string) => void;
	onDelete?: (content: string) => void;
	onSelect?: (content: string) => void;
	loading: boolean;
	data?: string[];
}

const SupplierEmailTableComponent: React.FC<IProps> = ({onEdit, onDelete, onSelect, loading, data}) => {

	let columns: any[] = [
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'description',
			width: '100%',
		},
	];

	if (onEdit && onDelete) {
		columns = [{
			title: 'Edit',
			dataIndex: 'edit',
			key: 'edit',
			width: '5%',
			render: (text: any, record: {email: string}) =>
				<Button
					title={'Edit'}
					style={{ border: 0 }}
					icon={<EditOutlined />}
					onClick={() => onEdit(record.email)}
				/>,
		},
		{
			title: 'Delete',
			dataIndex: 'delete',
			key: 'delete',
			width: '5%',
			render: (text: any, record: {email: string}) =>
				<Button
					title={'Delete '}
					style={{ border: 0 }}
					icon={<DeleteOutlined style={{ color: 'red' }} />}
					onClick={() => onDelete(record.email)}
				/>,
		}, ...columns]
	}

	if (onSelect) {
		columns = [{
			title: 'Select',
			dataIndex: 'select',
			key: 'select',
			width: '5%',
			render: (text: any, record: {email:string}) =>
				<Button
					title={'Edit'}
					style={{ border: 0 }}
					icon={<ArrowRightOutlined />}
					onClick={() => onSelect(record.email)}
				/>,
		}
		, ...columns]
	}

	return (
		<Table
			scroll={{ x: true }}
			loading={loading}
			columns={columns}
			dataSource={data?.map(x => {return {email: x}})}
		/>
	)
}

export default SupplierEmailTableComponent
